import styled from 'styled-components'
import ReactSelect from 'react-select'

export const Select = styled(ReactSelect)``

export const CardContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-end;
  gap: 4px;
  width: fit-content;
  .txtContainer {
    display: flex;
    gap: 8px;
    flex-direction: column;
  }
  .upperTxt {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0;
    font-family: Inter;
    color: '#000';
  }
  .lowerTxt {
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.1%;
    font-family: Inter;
    color: '#000';
  }
  .green {
    color: #00cd52;
  }
  .boldTxt {
    font-weight: 700;
  }
`
